import { ExternalLink } from "lucide-react";
import PropTypes from "prop-types";

const DealerManualsView = ({ dealerManuals }) => (
  <div className="animate-fade-in">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {dealerManuals.map(m => (
        <div key={m.id} className="wallet-card">
          <h3 className="text-lg font-bold text-white mb-2">{m.title}</h3>
          <p className="text-gray-400 text-sm mb-4 line-clamp-2">{m.description}</p>
          <a href={`/admin/manuals/${m.id}`} target="_blank" rel="noopener noreferrer"
            className="btn-lojack text-sm inline-flex items-center gap-2">
            <ExternalLink size={14} /> Leggi Manuale
          </a>
        </div>
      ))}
    </div>
  </div>
);

export default DealerManualsView;

DealerManualsView.propTypes = {
  dealerManuals: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  })).isRequired,
};
